<template>
  <div v-if="renderReady">
    <p v-if="getTitle" class="label w-monaco__label">
      <template>{{ getTitle }}</template>

      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
    </p>

    <monaco-editor
      v-model="model.$value"
      class="editor"
      :aria-invalid="errorVisible"
      :aria-describedby="errorVisible ? errId : undefined"
      :class="borderValidationClass"
      :options="monacoOptions"
      :language="language"
      @editorDidMount="startListeners"
    />

    <w-error :err-id="errId" :model="model" />
  </div>
</template>

<script>
import MonacoEditor from 'vue-monaco';

import modelMixin from '../mixins/modelMixin';
import { errorMixin } from '../mixins/errorMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'WMonaco',
  components: { MonacoEditor, WError, WTooltip },
  mixins: [modelMixin, errorMixin('monaco')],
  vmodel: true,
  props: {
    language: {
      type: String,
      required: false,
      default: 'javascript'
    }
  },
  data() {
    return { editor: undefined };
  },
  computed: {
    monacoOptions() {
      if (this.disabled) {
        return { readOnly: true };
      }
    }
  },
  methods: {
    startListeners(editor) {
      this.editor = editor;
      editor.onDidFocusEditorText(() => this.onFocus());
      editor.onDidBlurEditorText(() => this.onBlur());
    }
  }
};
</script>

<style>
.editor {
  min-height: 400px;
  border: 1px solid #cacaca;
}

.editor.is-invalid {
  border-color: #dc3545 !important;
}

.editor.is-warning {
  border-color: #ffc107 !important;
}
</style>
